<div class="dashboard-header">
    
    <nav class="navbar navbar-expand-lg bg-white fixed-top">
        <a class="navbar-brand" href="#"><img src="assets/images/logo.png" class="img-fluid" alt=""></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
            (click)="sidebarOpen">
            <span class="navbar-toggler-icon"></span>
        </button>
        <!-- <mat-icon (click)="change_nav()" >menu</mat-icon> -->

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto navbar-right-top">
                <li class="nav-item dropdown nav-user">
                    <a class="nav-link nav-user-img d-flex align-items-center justify-content-between" href="#"
                        id="navbarDropdownMenuLink2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="nav-user-info">
                            <h5 class="mb-0  nav-user-name">{{restroName}} </h5>
                            <span class="status"></span><span>Available</span>
                        </div>
                        <img src="assets/images/avatar-1.jpg" alt="" class="user-avatar-md rounded-circle">
                    </a>
                    <div class="dropdown-menu dropdown-menu-right nav-user-dropdown"
                        aria-labelledby="navbarDropdownMenuLink2"
                        [style.display]="sidebarVisible ? 'block' : 'd-lg-none'">
                        <a class="dropdown-item" href="#"><i class="fas fa-user mr-2"></i>Account</a>
                        <!-- <a class="dropdown-item" href="#"><i class="fas fa-cog mr-2"></i>Setting</a> -->
                        <a href="javascript:void(0)" class="dropdown-item" (click)="closseFunction()" style="cursor: pointer;"><i
                                class="fas fa-power-off mr-2"></i>Logout</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</div>